module.exports = __webpack_public_path__ + "img/logo.86ad9d89.svg";